import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { GoogleService } from '../../../../../server/src/services/google.service';
import { VisitorCalendarActionCommand, VisitorStyleCommand } from '../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../../../commands/visitor/all.frontend.settings.command';
import { MatFieldComponent } from '../../../common/components';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { FacebookPost } from '../../../common/components/facebook.post/facebook.post';
import { ImageComponent } from '../../../common/components/image/image.component';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { ModalService } from '../../../common/services/modal.service';
import { HubPlace, PlaceBusinessStatus } from '../../../models/hub/hub.place';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef, MatMenuTrigger } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import { PlaceDetailsModalActions } from 'components/visitor/place.details.modal/place.details.modal.provider';
import { GooglePlaceReview, HubPlaceAdditionalData } from '../../../models/hub/hub.google.place.data';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { ConfigService } from '../../../services/config.service';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { ImageService } from '../../../services/image.service';
import { PlaceService } from '../../../services/place.service';
import { ShareService } from '../../../services/share.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { config } from '../../../../config/config';
import {
  AllFrontendSettingsStore,
  VisitorCalendarStore,
  VisitorDataCache,
  VisitorStyleStore,
  VisitorTripNotifyAddOrRemoveItemStore,
} from '../../../stores/visitor.calendar.store';
import { ShowInfoModalComponent } from '../../hub/show.info.modal/show.info.modal.component';
import { ShowInfoModalActions, InfoModalData } from '../../hub/show.info.modal/show.info.modal.provider';
import { ImageViewerComponent } from 'common/components/image.viewer/image.viewer.component';
import { GlobalEventEmitter } from '../../../common/services/global.event.emitter';
import { SeoService } from '../../../services/seo.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AlertifyService } from '../../../services/alertify.service';

@Component({
  templateUrl: './place.details.modal.component.html',
  styleUrls: ['./place.details.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlaceDetailsModalComponent extends BaseComponent {
  public place: HubPlace;
  public googlePlaceAdditionalData: HubPlaceAdditionalData;
  public googleReviews: GooglePlaceReview[];
  public placePhotos = [];
  public priceLevel = [];
  public isAccommodation = false;
  public placeImagesShownCount = 5;
  public hubName: string;
  public fromUrl: string;
  public addressSegs: string[];
  public imageHeight = 350;
  public mapColumnMaxHeight = 703;
  public inforRowHeight = 0;
  public facebookLogo = config.facebook.logo;
  public placeFeeds: FacebookPost[];
  public placeFeedRows = [];
  public placeFeedPaging: { next: string };
  public isLoadingAllPlaces = false;
  public isLoadingPlace = false;
  public isMatchCompleted = false;
  public isGooglePlaceMatchedWithFBPlace = false;
  public isGoogleInfoLoaded = false;
  public isKeepTempClosedPlaceInApproved = false;
  public allPlaces = [];
  public mapZoom = 16;
  public hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
  public featuresToggle = new HubVisitorFeatureToggle();
  public placeSource = 'facebook';
  public _360Url: SafeResourceUrl;
  public _youtubeUrl: SafeResourceUrl;
  public analytics = new PlaceAnalytics();
  @ViewChild('mapColumn') public mapColumnEle: ElementRef;
  @ViewChild('image') public imageEle: ElementRef;
  @ViewChild('description') public descriptionEle: ElementRef;
  @ViewChild('imgComp') public imgComp: ImageComponent;
  @ViewChild('imgViewer') public imgViewer: ImageViewerComponent;
  @ViewChild('tripTitle') public tripTitle: MatFieldComponent;
  @ViewChild('menuTrigger') public menuTrigger: MatMenuTrigger;

  constructor(
    private dialogRef: MatDialogRef<PlaceDetailsModalComponent>,
    private actions: PlaceDetailsModalActions,
    private visitorApiService: VisitorApiService,
    private modalService: ModalService,
    private imageService: ImageService,
    private location: Location,
    private router: Router,
    private formBuilder: FormBuilder,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    private customizationApiService: CustomizationApiService,
    private visitorCalendarStore: VisitorCalendarStore,
    private visitorStyleStore: VisitorStyleStore,
    private notifyAddOrRemoveItemStore: VisitorTripNotifyAddOrRemoveItemStore,
    private sanitizer: DomSanitizer,
    private alertify: AlertifyService,
    data: HubPlace
  ) {
    super();
    this.place = data;
  }

  // @HostListener('window:popstate', ['$event'])
  // public hashChanged() {
  //     // solve the browser's back button is triggered, place calendar shows empty content issue
  //     setTimeout(() => {
  //         console.log('back btn', this.router.url);

  //         if (this.router.url.includes('/trips')) {
  //             // navigate to trip page in visitor.trip.component.ts
  //         } else {
  //             this.router.navigateByUrl(
  //                 getRouteUrl(routeConfigs.visitor.placeCalendar, {
  //                     hubName: this.hubName,
  //                     category: 'All',
  //                     menuType: 'normal',
  //                 }),
  //                 { skipLocationChange: this.noChangeUrlWhenRedirect }
  //             );
  //         }
  //     }, 200);
  // }

  /**
   * handle browser back button click, close the event details page
   * only close the details page is not enough, it will always have other loading issues for the script embedding solution
   * so force reload the page for now
   * */
  @HostListener('window:popstate', ['$event'])
  public hashChanged($event: Event) {
    $event.preventDefault();
    console.log('prevent default');
    let url = window.location.href.split('imgoing-place')[0];
    url = url.endsWith('?') ? url.substring(0, url.length - 1) : url;
    window.location.href = url;
    this.close();
  }

  public get contentLoaded() {
    return (
      this.place &&
      ((this.place.socialName === 'google' && this.isGoogleInfoLoaded) || this.place.socialName !== 'google')
    );
  }

  public get hasDescription() {
    return this.place.description || this.place.about;
  }

  public ngAfterContentInit() {
    this.facebookLogo = this.imageService.imageSourceUrl(this.facebookLogo);

    // this component cannot get the Facebook login event (don't know why so far), so it uses this global event emitter to receive the login status
    GlobalEventEmitter.on('onFBLoginStatusChanged', () => {
      console.log('onFBLoginStatusChanged received');
      this.getFacebookPlaceFeed(null);
    });

    this.allFrontendSettingsStore.allFrontendSettingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.toggle) {
          this.featuresToggle = command.toggle;
          this.placeSource = command.dataSource ? command.dataSource.place : this.place.socialName || 'facebook';
        }
        if (command.customSettings && command.customSettings.placeImagesShownCount) {
          this.placeImagesShownCount = command.customSettings.placeImagesShownCount;
        }
        if (command.customSettings && command.customSettings.isKeepTempClosedPlaceInApproved) {
          this.isKeepTempClosedPlaceInApproved = command.customSettings.isKeepTempClosedPlaceInApproved;
        }        
      });

    // this.hubName = data.hubName;
    // if (data && data.placeId) { // placeId, from VisitorCalendarComponent
    //     this.loadPlaces(data.placeId, data.hubName);
    // } else {
    //     this.loadItem(data);
    // }

    this.hubName = this.place.hubName;
    if (this.place && this.place.placeId) {
      // No place details loaded, need to load. placeId, from VisitorCalendarComponent
      this.loadPlaces(this.place.placeId, this.place.hubName);
    } else {
      this.loadItem(this.place);
    }
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
    GlobalEventEmitter.off('onFBLoginStatusChanged');

    if (config.isAnalyticsOn) {
      console.log('destroy', this.analytics);
      this.visitorApiService.updatePlaceAnalytics(this.hubName, this.place.id, this.analytics).subscribe();
    }
  }

  public get noPostBackground() {
    return (
      ((this.place.socialName === 'facebook' || this.place.isManuallyCreated) &&
        (!this.place.hostLink || this.place.hostLink.indexOf('facebook.com/') < 0)) ||
      (this.place.socialName === 'google' && !this.googleReviews)
    );
  }

  public close(): void {
    if (this.actions.cancel) {
      this.actions.cancel();
    }

    this.dialogRef.close();
  }

  public confirm(event: ButtonTriggerEvent) {
    this.actions.confirm(event);
    this.dialogRef.close();
  }

  private loadPlaces(placeId?, hubName?) {
    this.isLoadingPlace = true;
    this.getPlaceById(hubName, placeId || this.place._id).subscribe((p) => {
      this.isLoadingPlace = false;
      if (p && p.length) {
        this.loadItem(p[0]);
      } else {
        this.modalService.showErrorModal('Place id is wrong!');
      }
    });
  }

  private getFBPost(placeId) {
    if (placeId) {
      FB.api(
        config.facebook.graphApi.placePosts
          .replace('${accessToken}', config.facebook.approvedApps[0])
          // .replace('${accessToken}', FacebookLoginButtonComponent.userAccessToken)
          .replace('${placeId}', placeId),
        (response) => {
          this.placeFeedPaging = response.paging;

          if (!!response.error) {
            console.error(response.error);
            this.placeFeeds = [];
            return;
          }

          this.updatePlaceFeeds(response.data);
        }
      );
    }
  }

  public getFacebookPlaceFeed($event) {
    if (!this.place) {
      return;
    }
    if (
      this.place.socialName === 'google' &&
      this.featuresToggle.facebookPosts &&
      FacebookLoginButtonComponent.isUserLoggedWithFacebook
    ) {
      // search Facebook place API is deprecated
      //this.matchGooglePlaceWithFacebookPlace();
    }
    if (this.place.socialName === 'facebook') {
      if (FacebookLoginButtonComponent.isUserLoggedWithFacebook && !this.placeFeeds) {
        let id = ShareService.getFacebookPlaceId(this.place.hostLink);
        this.getFBPost(id);
      }
      // else {
      //     // the facebook login button component's loginStatusChange event cannot take effect here
      //     setTimeout(() => {
      //         this.getFacebookPlaceFeed(null);
      //     }, 3000);
      // }
    }
  }

  public getNextFacebookPlaceFeed(event: ButtonTriggerEvent) {
    FB.api(this.placeFeedPaging.next, (response) => {
      event.complete();
      this.placeFeedPaging = response.paging;

      if (!!response.error) {
        console.error(response.error);
        return;
      }

      this.updatePlaceFeeds(this.placeFeeds.concat(response.data));
    });
  }

  public async getGooglePlaceDetails(place) {
    if (place.socialName === 'google') {
      this.googlePlaceAdditionalData = await PlaceService.getGooglePlaceDetails(
        this.place,
        this.hubName,
        this.visitorApiService
      );
      if (this.googlePlaceAdditionalData.isNotExistInSource) {
        this.alertify.error("Uh-oh! Looks like we haven't found this place! Please view other places in the list!");
        this.dialogRef.close();
        return;
      }
      this.googleReviews = this.googlePlaceAdditionalData
        ? this.googlePlaceAdditionalData.googleReviews || this.googlePlaceAdditionalData.reviews
        : [];
      this.place.website =
        this.place.website || (this.googlePlaceAdditionalData ? this.googlePlaceAdditionalData.website : null);
      this.place.phone =
        this.place.phone ||
        (this.googlePlaceAdditionalData ? this.googlePlaceAdditionalData.formatted_phone_number : null);
      this.place.hostGoogleLink = this.googlePlaceAdditionalData ? this.googlePlaceAdditionalData.url : null;

      const range =
        this.place.priceRange ||
        (this.googlePlaceAdditionalData
          ? this.googlePlaceAdditionalData.priceRange || this.googlePlaceAdditionalData.price_level
          : null);
      this.place.priceRange = range ? this.getPriceRangeSymbol(range) : '';

      if (this.place.cover && this.place.cover.source) {
        this.place.cover.source = this.imageService.imageSource(this.place);
      }
      // photoRealSources is the edited photos (client can set to show which photo of a Google place)
      let photos = this.getPlaceImages();
      let isReal = !!(
        this.googlePlaceAdditionalData.allowedGooglePhotos && this.googlePlaceAdditionalData.allowedGooglePhotos.length
      );
      photos = photos.map((x) => {
        return PlaceService.getGooglePlaceImageFullUrl(
          x.photo_reference || x,
          this.googlePlaceAdditionalData.appKey,
          isReal,
          false
        );
      });

      photos.shift();
      this.placePhotos = [this.place.cover.source, ...photos];

      this.place.business_status = this.googlePlaceAdditionalData.business_status as PlaceBusinessStatus;
      this.placeImagesShownCount = Math.min(this.placeImagesShownCount, this.placePhotos.length);
      this.isGoogleInfoLoaded = true;
    }
  }

  public gotoPlace(place) {
    this.isGoogleInfoLoaded = false;
    this.isMatchCompleted = false;
    this.isGooglePlaceMatchedWithFBPlace = false;
    this.placeFeeds = null;
    this.placeFeedPaging = null;

    this.loadItem(place);
  }

  public visitWebsite() {
    if (this.place.website || this.place.hostLink) {
      window.open(this.place.website || this.place.hostLink, '_blank');
    } else if (this.googlePlaceAdditionalData && this.googlePlaceAdditionalData.website) {
      window.open(this.googlePlaceAdditionalData.website, '_blank');
    }
  }

  public getDirection() {
    let address = this.place.address.address || this.place.address;
    let url = config.eventShare.googleMapGetDirection.replace('${address}', encodeURIComponent(address.toString()));
    window.open(url, '_blank');
  }

  public showPlaceLink() {
    this.modalService.show({
      component: ShowInfoModalComponent,
      providers: [
        { provide: ShowInfoModalActions, useValue: null },
        {
          provide: InfoModalData,
          useValue: new InfoModalData(
            'Place Link',
            null,
            [`${config.serverDomain}${this.place.hubName}/place-details/${this.place._id}`],
            null,
            true
          ),
        },
      ],
      panelClass: 'width-modal-4',
    });
  }

  public viewFBPage() {
    if (this.place.hostLink || this.place.hostFacebookLink) {
      window.open(this.place.hostLink || this.place.hostFacebookLink, '_blank');
    }
  }

  private loadItem(place) {
    if (!place) {
      return;
    }
    this.setImageSizeForGooglePlaces(place);
    this.imgComp && this.imgComp.updateImage(place.cover && place.cover.source);
    this.imgViewer && this.imgViewer.updateImage(place.cover && place.cover.source);
    place.category && (place.category = PlaceService.allToReadableCategory(place.category));
    this.place = place;
    this.processAddress();
    // this.loadPlaceMoreInfo();
    this.isAccommodation = PlaceService.checkIsAccommodation(this.place);

    if (!this.isScriptSolution) {
      SeoService.addNameIdToUrlForPlaceForNonScriptSolution(this.location, this.place, this.dialogRef);
    } else {
      // for clients who use the script solution (embed ImGoing as a script into client's website)
      // change the URL by adding the ImGoing place name + Id to the params so that each place has a unique URL
      // when close the details modal, reset the URL to the original URL of the host site
      if (SeoService.getIfNeedToAddNameIdToUrl()) {
        SeoService.addNameIdToUrlForPlaceForScriptSolution(place, this.dialogRef);
      }
    }

    setTimeout(async () => {
      this.isLoadingAllPlaces = false;
      this.setElementHeight();

      this.placeFeeds = null;
      this.placeFeedPaging = null;
      this.getFacebookPlaceFeed(null);
      this.place.priceRange = this.getPriceRangeSymbol(this.place.priceRange);
      await this.getGooglePlaceDetails(place);

      if (this.place._360VideoKey) {
        this._360Url = this.sanitizer.bypassSecurityTrustResourceUrl(
          config._360VideoUrl.replace('${id}', this.place._360VideoKey)
        );
      }
      if (this.place.youtubeLink && this.place.youtubeLink.indexOf('watch?v=') >= 0) {
        // Youtube video link looks like:
        // https://www.youtube.com/watch?v=puKsjFRwIyw
        // https://www.youtube.com/watch?v=puKsjFRwIyw&t=27s
        const code = this.place.youtubeLink.split('watch?v=')[1].split('&')[0];
        this._youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(config.youtubeUrl.replace('${code}', code));
      }

      SeoService.createAndInjectGoogleStructureDataScriptForPlace(this.place);
    });
  }

  private loadPlaceMoreInfo() {
    this.isLoadingPlace = true;
    this.getPlaceById(this.place.hubName, this.place._id).subscribe((data: any) => {
      if (data && data.length) {
        this.place.description = data[0].description;
        this.place.about = data[0].about;
        this.place.address = data[0].address;
        this.place.category = data[0].category;
        this.processAddress();
      }
      this.isLoadingPlace = false;
    });
  }

  private processAddress() {
    let address = (this.place.address.address || this.place.address).toString();
    let addSegs = address.split(',');
    let last = addSegs[addSegs.length - 1];
    let cityArr = [],
      no = [];
    let take = parseInt(last, 10) ? 3 : 2;
    addSegs.forEach((x, index) => {
      if (index < addSegs.length - take) {
        no.push(x);
      } else {
        cityArr.push(x);
      }
    });
    this.addressSegs = [...no, cityArr.join(', ')];
  }

  private setElementHeight() {
    // let rect = this.mapColumnEle.nativeElement.getBoundingClientRect();
    // this.inforRowHeight = Math.min(rect.height, this.mapColumnMaxHeight);
    // this.mapColumnEle.nativeElement.style.height = this.inforRowHeight + 20 + 'px';
    // let desHeight = this.inforRowHeight - this.imageHeight - 25;//imageEleRect.height - 8;
    // this.descriptionEle.nativeElement.style.display = 'block';
    // this.descriptionEle.nativeElement.style.height = desHeight + 'px';
    // this.fbposts ? this.fbposts.nativeElement.style.height = (this.inforRowHeight - 32) + 'px' : null;
  }

  private updatePlaceFeeds(placeFeeds) {
    this.placeFeeds = placeFeeds;
    this.placeFeeds.forEach((x) => {
      x.from.link = config.facebook.graphApi.profile.replace('${userId}', x.from.id);
      x.from.picture = config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
    });
    // show 2 columns for facebook place
    if (this.show2ColumnsFacebookFeeds) {
      let col = [];
      this.placeFeedRows = [];
      this.placeFeeds.forEach((x, i) => {
        if (i && i % 2 === 0) {
          this.placeFeedRows.push(col);
          col = [];
        }
        col.push(x);
        if (i === this.placeFeeds.length - 1) {
          this.placeFeedRows.push(col);
        }
      });
    }
  }

  public get show2ColumnsFacebookFeeds() {
    return (
      this.place.socialName === 'facebook' || (this.place.socialName === 'google' && !this.featuresToggle.googleReviews)
    );
  }

  public addGotoWebsiteCount() {
    this.analytics.gotoWebsiteCount++;
  }

  public addGetDirectionCount() {
    this.analytics.getDirectionCount++;
  }

  public addShareEmail() {
    this.analytics.shareEmailCount++;
  }

  public addShareFB() {
    this.analytics.shareFBCount++;
  }

  public addShareTweet() {
    this.analytics.shareTweetCount++;
  }

  public addGoToGoogleReview() {
    this.analytics.gotoGoogleReview++;
  }

  private getPlaceById(hubName, id): Observable<HubPlace[]> {
    return this.visitorApiService.getPlaces(hubName || this.place.hubName, {
      page: 1,
      limit: 1,
      category: 'All',
      id,
    });
  }

  private setImageSizeForGooglePlaces(place) {
    if (
      place.cover &&
      place.cover.source &&
      place.cover.source.indexOf('maps.googleapis.com/maps/api/place/photo?maxwidth=480') >= 0
    ) {
      place.cover.source = place.cover.source.replace('maxwidth=480', 'maxwidth=960');
    }
  }

  private matchGooglePlaceWithFacebookPlace() {
    PlaceService.getMatchedFacebookPlaceId(this.place, this.hubName, this.visitorApiService).then((data) => {
      console.log(data);
      this.isMatchCompleted = true;
      if (data.isMatched) {
        this.isGooglePlaceMatchedWithFBPlace = true;
        // this.place.description = data.description;
        this.place.hostFacebookLink = data.link;
        let id = ShareService.getFacebookPlaceId(data.link);
        this.getFBPost(id);
      } else {
        this.placeFeeds = []; // no Facebook posts
      }
    });
  }

  private getPlaceImages(): any[] {
    if (
      this.googlePlaceAdditionalData.allowedGooglePhotos &&
      this.googlePlaceAdditionalData.allowedGooglePhotos.length
    ) {
      return this.googlePlaceAdditionalData.allowedGooglePhotos;
    }
    // use the cover image to replace the first one in the photos, to reduce request calls
    if (this.googlePlaceAdditionalData.photos && this.googlePlaceAdditionalData.photos.length) {
      this.googlePlaceAdditionalData.photos.shift();
      this.googlePlaceAdditionalData.photos.unshift({
        height: 0,
        photo_reference: this.place.cover ? this.place.cover.source : 'null',
        width: 0,
        html_attributions: null,
      });
      return this.googlePlaceAdditionalData.photos;
    }
    if (this.place.cover && this.place.cover.source) {
      return [this.place.cover.source];
    }
    return [];
  }

  private getPriceRangeSymbol(price: string | number): string {
    if (!price) return '';

    if (price.toString().startsWith('$')) return price.toString();

    let array: string[] = [];
    for (let i = 0; i < +price; i++) {
      array.push('$');
    }
    return array.join('');
  }
}

export class Analytics {
  public getDirectionCount: number;
  public gotoGoogleReview: number;
  public shareEmailCount: number;
  public shareFBCount: number;
  public shareTweetCount: number;

  constructor() {
    this.getDirectionCount = 0;
    this.gotoGoogleReview = 0;
    this.shareEmailCount = 0;
    this.shareFBCount = 0;
    this.shareTweetCount = 0;
  }
}

export class PlaceAnalytics extends Analytics {
  public gotoWebsiteCount: number;

  constructor() {
    super();
    this.gotoWebsiteCount = 0;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/place.details.modal/place.details.modal.component.ts